export enum TravelArea {
    Domestic = "D",
    Asia = "A",
    Worldwide = "W"
  }
  
  export const TRAVEL_AREA_LABEL_MAP = {
    [TravelArea.Domestic]: "Domestic",
    [TravelArea.Asia]: "Asia",
    [TravelArea.Worldwide]: "Worldwide"
  };
  
  export function getTravelAreaLabel(travelArea: string): string {
    return TRAVEL_AREA_LABEL_MAP[travelArea] || "";
  }
  
  export function getTravelAreaList(): string[] {
    return Object.keys(TRAVEL_AREA_LABEL_MAP);
  }
  